import axios from 'axios';
import qs from 'qs';
import { StrapiResponse } from '../interfaces/commons';

const instance = axios.create();

import {
  LessonTemplate,
  LessonTemplateAttributes,
  LessonTemplatesListResponse,
} from '../interfaces/lesson-templates';
import { lessonCategory } from '../constants/course';

const { REACT_APP_API_URL } = process.env;

export const getLessonTemplates = async (
  searchParams: any,
  token: string | null
) => {
  const selectedCategory = lessonCategory.filter(({ title }) =>
    searchParams.getAll('category').find((v: string) => v === title)
  );

  const categoryArr = selectedCategory.map((object) => object.id);

  const query = {
    populate: ['*', 'category'],
    sort: { updatedAt: 'desc' },
    filters: {
      title: { $contains: searchParams.get('search') },
      isVisible: { $eq: true },
      $and: [
        {
          category: { $in: categoryArr },
        },
        {
          endCourse: { $eq: searchParams.get('endCourse') },
        },
      ],
    },
    pagination: {
      page: searchParams.get('page'),
      pageSize: searchParams.get('pageSize') || 100,
    },
  };

  const { data } = await axios.get<LessonTemplatesListResponse>(
    `${REACT_APP_API_URL}/lesson-templates?${qs.stringify(query, {
      skipNulls: true,
    })}`,
    {
      headers: { authorization: `Bearer ${token}` },
    }
  );

  return data;
};

export const getLessonTemplate = async (
  lessonTemplateId: string | number,
  token: string | null
) => {
  const query = {
    populate: ['availableTeacher', 'teacherAutoAssignLessons', 'slidePdf'],
  };

  const { data } = await axios.get<StrapiResponse<LessonTemplate>>(
    `${REACT_APP_API_URL}/lesson-templates/${lessonTemplateId}?${qs.stringify(
      query
    )}`,
    {
      headers: { authorization: `Bearer ${token}` },
    }
  );
  return data;
};

export const findOptions = async ({
  token,
  query = {},
  pageSize = 300,
}: {
  token: string | null;
  query?: object;
  pageSize?: number;
}) => {
  const requestQuery = {
    ...query,
    populate: ['courseLessonTemplate.courseTemplate'],
    sort: { title: 'asc' },
    filters: {
      ...(query as any)?.filters,
      isVisible: { $eq: true },
    },
    pagination: {
      pageSize,
    },
  };

  const { data } = await axios.get<LessonTemplatesListResponse>(
    `${REACT_APP_API_URL}/lesson-templates?${qs.stringify(requestQuery, {
      skipNulls: true,
    })}`,
    {
      headers: { authorization: `Bearer ${token}` },
    }
  );

  return data;
};

export const postLessonTemplate = async (
  newLessonTemplate: LessonTemplateAttributes,
  token: string | null,
  slidePdf?: File[]
) => {
  const formData = new FormData();
  const body = { ...newLessonTemplate };
  delete body.slidePdf;
  
  formData.append('data', JSON.stringify(body));
  
  if (slidePdf && slidePdf.length > 0)
    formData.append('files.slidePdf', slidePdf[0], slidePdf[0]?.name);

  const { data } = await instance.post<StrapiResponse<LessonTemplate>>(
    `${REACT_APP_API_URL}/lesson-templates`,
    formData,
    {
      headers: { authorization: `Bearer ${token}` },
    }
  );
  return data;
};

export const putLessonTemplate = async (
  lessonTemplateId: string | number,
  updatedLessonTemplate: LessonTemplateAttributes,
  token: string | null,
  slidePdf?: File[]
) => {
  const formData = new FormData();
  const body = { ...updatedLessonTemplate };
  delete body.slidePdf;
  
  formData.append('data', JSON.stringify(body));
  
  if (slidePdf && slidePdf.length > 0)
    formData.append('files.slidePdf', slidePdf[0], slidePdf[0]?.name);

  const { data } = await instance.put<any>(
    `${REACT_APP_API_URL}/lesson-templates/${lessonTemplateId}`,
    formData,
    {
      headers: { authorization: `Bearer ${token}` },
    }
  );
  return data;
};

export const delLessonTemplate = async (
  lessonTemplateId: string | number,
  token: string | null
) => {
  const { data } = await instance.delete<any>(
    `${REACT_APP_API_URL}/lesson-templates/${lessonTemplateId}`,
    {
      headers: { authorization: `Bearer ${token}` },
    }
  );
  return data;
};
